<template>
  <metainfo>
    <template v-slot:title="{ content }">{{
      content ? `${content}` : `เติมเกม เติมเกมมือถือ บริการเติมเกม เติมเกมราคาถูก pubg freefire rov valorant ragnarok | Richman Shop`
    }}</template>
  </metainfo>
  <router-view></router-view>
</template>

<script setup>
import useTokenGenerator from "./composable/useTokenGenerator";
useTokenGenerator();

</script>
<style >
.ant-btn-primary {
  background-color: #fbe112 !important;
  border-color: #fbe112 !important;
  color: #5d5d5d !important;
}
.btn-info {
  background-color: #fbe112 !important;
  color: #5d5d5d !important;
}
.btn-outline-info {
  border-color: #fbe112 !important;
  color: #5d5d5d !important;
}
.ant-btn-primary:hover {
  background: #fbe112 !important;
  border-color: #fbe112 !important;
}
.ant-btn-round {
  color: #fbe112 !important;
  border-color: #fbe112 !important;
}

.ant-btn-default:hover {
  color: #5d5d5d !important;
  background: #646464 !important;
  border-color: #646464 !important;
}

.ant-btn-round:hover {
  color: #5d5d5d !important;
  background: #fbe112 !important;
  border-color: #fbe112 !important;
}

.btn-primary {
  color: #5d5d5d !important;
  background-color: #fbe112 !important;
  border-color: #fbe112 !important;
}

.sidebar,
.off-canvas-sidebar {
  z-index: 1000 !important;
}

.ant-card-meta-description {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.navbar-expand-lg .navbar-toggler {
  display: block !important;
}
.navbar-expand-lgg .navbar-toggler {
  display: none !important;
}

/* .swal2-icon-content {
  font-size: 0.75em !important;
} */
/* 
.text-right {
  text-align: right;
}
.text-center {
  text-align: center;
} */
</style>